import styled from 'styled-components';
import { MenuItem as MuiMenuItem, Popover } from '@mui/material';

export const MainInformation = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.common.white};
  display: flex;
  padding: 20px;
  padding-right: 40px;
  flex-direction: row;
  margin-top: 20px;
  font-size: 16px;
  height: 90px;
  align-items: center;
`;

export const UserName = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 20px;
  font-weight: 500;
  margin: 0;
`;

export const MainInformationColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
  margin-right: 30px;
  p {
    margin: 0;
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 16px;
    font-weight: 400;
  }
`;

export const MainInformationTitle = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 600;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin: 0;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-between;
  button {
    margin-left: 1rem;
  }
`;
export const StyledPopover = styled(Popover)`
  box-shadow: none;
  border: none;
  border-radius: 0.5rem;
`;

export const InactiveBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(2.5)};
  padding: ${({ theme }) => theme.spacing(1.5, 2.5)};
  border-radius: ${({ theme }) => theme.spacing(1)};
  border: 1px solid ${({ theme }) => theme.palette.warning.main};
  background: ${({ theme }) => theme.toast.warning.background};
`;

export const InactiveBannerMessage = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const InactiveBannerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.25)};
`;

export const InactiveBannerTitle = styled.span`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

export const InactiveBannerBody = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
  line-height: 20px;
`;

export const MenuItem = styled(MuiMenuItem)`
  font-size: 14px;
  min-height: 44px;
  padding: 6px 16px;
`;
